import { __assign, __extends, __spreadArray } from "tslib";
import React, { Component } from 'react';
import { PnmacCard, PnmacHtmlToNative, PnmacMediaQuery, PnmacMessageCenter, PnmacMeta, PnmacModal, PnmacPageBubble, PnmacText, PnmacUIButton, PnmacMultiLineUIButton } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { GET_MESSAGES, SHOW_CHAT } from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import moment from 'moment';
import { windowObject } from '../utils.js';
import { Text, TouchableOpacity } from "react-native";
import BannerView from "../v2/BannerView";
import withPnmacTitle from '../withPnmacTitle';
var messageSubjects = require('./data/subjects.json');
var MessageCenter = /** @class */function (_super) {
  __extends(MessageCenter, _super);
  function MessageCenter(props) {
    var _this = this;
    var _a;
    _this = _super.call(this, props) || this;
    _this.onTabChange = function (tab) {
      var _a;
      if (_this.props) {
        if (tab.props.name == "compose") {
          //show chat.
          if (!((_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.showChat)) {
            _this.props.dispatch({
              type: SHOW_CHAT,
              showChat: true
            });
          }
        }
      }
    };
    _this.submittMessage = function (data, reply) {
      var _a, _b, _c, _d;
      var replytomessage = _this.state.messages.find(function (s) {
        return s.messageId == data.messageId;
      });
      var _e = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.layout,
        selectedLoanNumber = _e.selectedLoanNumber,
        trackerSession = _e.trackerSession;
      var form = new FormData();
      var fromChat = ((_b = _this.props.location) === null || _b === void 0 ? void 0 : _b.state) && ((_d = (_c = _this.props.location) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.fromChat);
      form.append('body', data.message);
      data.uploadedFiles.map(function (file, index) {
        form.append("file".concat(index), file);
      });
      form.append('loanId', selectedLoanNumber);
      form.append('subjectLid', parseInt(data.subject));
      form.append('trackersessionId', parseInt(trackerSession));
      form.append('Subjectname', _this.renderSubjectText(_this.props.language, parseInt(data.subject)));
      form.append('trackerURL', windowObject.location.pathname);
      if (fromChat) {
        form.append('chatLog', JSON.stringify(_this.props.layout.chatMessages));
      }
      if (reply) {
        form.append('parentMessageId', replytomessage.parentMessageId != 0 && replytomessage.parentMessageId != replytomessage.messageId ? replytomessage.parentMessageId : replytomessage.messageId);
      }
      fetch("api/messages/post_messages", {
        method: "POST",
        headers: {
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: form
      }).then(function (s) {
        if (s.ok) {
          _this.setState({
            show: "MessageSubmittedSuccess",
            open: true
          }, function () {
            return _this.props.refreshMessages(_this.changeViews("sent"));
          });
        }
      });
    };
    _this.setNavigation = function (func) {
      _this.changeViews = func;
    };
    _this.modalContent = function (show, matches) {
      var translations = _this.props.translations;
      switch (show) {
        case "NoNeedBillUpload":
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, translations.DoNotUploadTaxBillMsg), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, translations.DoNotUploadTaxBillMsgSecondPart)), /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: "100%",
              marginTop: 20,
              marginBottom: 20
            }
          }, /*#__PURE__*/React.createElement(PnmacMultiLineUIButton, {
            mode: "contained",
            matches: matches,
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.CntToSubmitComposeTabMsg)), /*#__PURE__*/React.createElement("div", {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement(PnmacUIButton, {
            mode: "outlined",
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.CancelText))));
          break;
        case "NoModificationDocumentsUpload":
          return /*#__PURE__*/React.createElement("div", {
            style: {
              backgroundColor: "white",
              borderRadius: 10,
              padding: 5,
              maxWidth: "500px"
            }
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: 'htmlToNative',
            dangerouslySetInnerHTML: {
              __html: translations.DoNotUploadYourModificationDocumentsInMessageCenter
            }
          }, /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center"
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: "75%",
              marginTop: 20,
              marginBottom: 20
            }
          }, /*#__PURE__*/React.createElement(PnmacUIButton, {
            mode: "contained",
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.SubmitQuestionRegardingModification)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacUIButton, {
            mode: "contained",
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.CancelText)))));
          break;
        case "MessageSubmittedSuccess":
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, translations.MessageSent), /*#__PURE__*/React.createElement("div", {
            className: 'htmlToNative',
            dangerouslySetInnerHTML: {
              __html: translations.ThankYouMessageSent
            }
          }), /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: "40%"
            }
          }, /*#__PURE__*/React.createElement(PnmacUIButton, {
            labelStyle: {
              color: "white"
            },
            mode: "contained",
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.Close))));
          break;
        case "PMIDivId":
          return /*#__PURE__*/React.createElement("div", {
            style: {
              backgroundColor: "white",
              borderRadius: 10,
              padding: 5,
              maxWidth: matches.small ? "90%" : "500px"
            }
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: 'htmlToNative',
            dangerouslySetInnerHTML: {
              __html: translations.PMIModalDialigMessage
            }
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement(PnmacUIButton, {
            mode: "contained",
            style: {
              width: matches.small ? "50%" : "40%",
              marginBottom: 15,
              marginTop: 30
            },
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.ContinueButtonSubmitPMI), /*#__PURE__*/React.createElement(PnmacUIButton, {
            mode: "outlined",
            style: {
              width: matches.small ? "50%" : "40%"
            },
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.CancelText)));
          break;
        case 'NoNeedInsuranceBillUpload':
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
            value: translations.DoNotUploadInsuranceBillMsg
          }))), /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: "100%",
              marginTop: 20,
              marginBottom: 20
            }
          }, /*#__PURE__*/React.createElement(PnmacMultiLineUIButton, {
            mode: "contained",
            matches: matches,
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.ContinueButtonInsurance)), /*#__PURE__*/React.createElement("div", {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement(PnmacUIButton, {
            mode: "outlined",
            onClick: function () {
              return _this.setState({
                open: false,
                show: ""
              });
            }
          }, translations.CancelText))));
          break;
      }
    };
    _this.fetchAttachedDoc = function (docID, fileName) {
      var _a;
      fetch("api/documents/get_docs_stream_download", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: JSON.stringify({
          docId: docID,
          loanId: (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanNumber,
          filName: fileName
        })
      }).then(function (s) {
        if (s.ok) {
          return s.text();
        }
      }).then(function (d) {
        var a = document.createElement("a"); //Create <a>
        a.href = "data:image/png;base64," + d; //Image Base64 Goes here
        a.download = fileName;
        a.click();
      });
    };
    _this.state = {
      messageRef: /*#__PURE__*/React.createRef(),
      messages: (_a = props.layout.selectedLoanMessages) !== null && _a !== void 0 ? _a : [],
      open: false,
      show: "",
      subjects: messageSubjects,
      senders: [{
        en: "Customer",
        value: 200269,
        es: "Customer"
      }, {
        en: "LAFA",
        value: 200270,
        es: "LAFA"
      }, {
        en: "**Automated Message**",
        value: 200271,
        es: "Mensajes autom\xE1ticos"
      }, {
        en: "**Automated Message**",
        value: 96,
        es: "Mensajes autom\xE1ticos"
      }, {
        en: "The Secure Message Team ",
        value: 200272,
        es: "The Secure Message Team "
      }]
    };
    return _this;
  }
  MessageCenter.getDerivedStateFromProps = function (props, state) {
    if (props.layout.selectedLoanMessages != state.selectedLoanMessages) {
      return __assign(__assign({}, state), {
        messages: props.layout.selectedLoanMessages
      });
    }
    return null;
  };
  MessageCenter.prototype.renderSubjectText = function (lang, subjectLID) {
    var subject = this.state.subjects.find(function (d) {
      return parseInt(d.value) == subjectLID;
    });
    if (subject) {
      return subject[lang];
    }
    return "N/A";
  };
  MessageCenter.prototype.renderSenderText = function (lang, senderLID) {
    var sender = this.state.senders.find(function (d) {
      return parseInt(d.value) == senderLID;
    });
    if (sender) {
      return sender[lang];
    }
    return "N/A";
  };
  MessageCenter.prototype.getComposeSubjects = function (lang) {
    var subjects = [];
    this.state.subjects.filter(function (s) {
      return s.showInCompose == true;
    }).forEach(function (sub) {
      return subjects.push({
        text: sub[lang],
        value: sub.value
      });
    });
    return subjects;
  };
  MessageCenter.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = this.props,
      translations = _h.translations,
      layout = _h.layout,
      matches = _h.matches;
    var show = this.state.show;
    var removedmessages = __spreadArray([], this.state.messages, true);
    if (removedmessages) {
      removedmessages.reverse();
    }
    var fromChat = ((_a = this.props.location) === null || _a === void 0 ? void 0 : _a.state) && ((_c = (_b = this.props.location) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.fromChat);
    var obj = function (allmessage) {
      var _a, _b;
      var s = allmessage[0];
      var read = false;
      if (s.messageRead && (allmessage.length == 0 || !allmessage.find(function (d) {
        return !d.messageRead;
      }))) {
        read = true;
      }
      return __assign(__assign({}, s), {
        message: ((_a = allmessage === null || allmessage === void 0 ? void 0 : allmessage.sort(function (a, b) {
          return new Date(b === null || b === void 0 ? void 0 : b.receivedDateTimeUtc) - new Date(a === null || a === void 0 ? void 0 : a.receivedDateTimeUtc);
        })) === null || _a === void 0 ? void 0 : _a.map(function (r) {
          var _a;
          return /*#__PURE__*/React.createElement("div", {
            key: "allmessage_".concat(r.messageId)
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              borderBottomWidth: 1,
              borderBottomColor: "#EFEFEF",
              borderBottomStyle: "solid",
              paddingBottom: 10,
              marginBottom: 20,
              fontWeight: "bold"
            }
          }, "Subject: ", s.document != null ? (_this.props.language == "en" ? s.document.englishName : s.document.spanishName) + " " + translations.AvailableText : !isNaN(s.subjectLID) ? _this.renderSubjectText(_this.props.language, s.subjectLID) : "N/A"), /*#__PURE__*/React.createElement("div", {
            style: {
              padding: 5
            }
          }, /*#__PURE__*/React.createElement("b", null, "From: ", _this.renderSenderText(_this.props.language, r === null || r === void 0 ? void 0 : r.senderLID))), /*#__PURE__*/React.createElement("div", {
            style: {
              padding: 5
            }
          }, /*#__PURE__*/React.createElement("b", null, "When: ", moment(r === null || r === void 0 ? void 0 : r.receivedDateTimeUtc).format("MM/DD/YYYY @ hh:mm:ss A"))), /*#__PURE__*/React.createElement("div", {
            style: {
              padding: 5
            }
          }, /*#__PURE__*/React.createElement("b", null, "Re: Loan #", r.loanId)), /*#__PURE__*/React.createElement("div", {
            style: {
              padding: 15
            }
          }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
            value: r.body
          })), (_a = r === null || r === void 0 ? void 0 : r.attachment) === null || _a === void 0 ? void 0 : _a.map(function (w) {
            return /*#__PURE__*/React.createElement(TouchableOpacity, {
              id: "document" + w.docId,
              key: "attachment_".concat(r.messageId, "_").concat(w.docId),
              style: {
                cursor: "pointer"
              },
              onPress: function () {
                return _this.fetchAttachedDoc(w.docId, w.originalFileName);
              }
            }, /*#__PURE__*/React.createElement("view", {
              style: {
                padding: 15
              }
            }, /*#__PURE__*/React.createElement("img", {
              alt: "Paperclip image",
              style: {
                width: 15,
                height: 15,
                margin: 3
              },
              src: require("../assets/paperclip.png")
            }), /*#__PURE__*/React.createElement(Text, null, w.originalFileName)));
          }));
        })) || [],
        subject: s.document != null ? (_this.props.language == "en" ? s.document.englishName : s.document.spanishName) + " " + translations.AvailableText : !isNaN(s.subjectLID) ? _this.renderSubjectText(_this.props.language, s.subjectLID) : "N/A",
        recieved: moment(s.receivedDateTimeUtc).format("MM/DD/YYYY hh:mm:ss a"),
        from: !isNaN(s.senderLID) ? _this.renderSenderText(_this.props.language, s.senderLID) : "N/A",
        direction: parseInt(s.senderLID),
        submissionDate: s.receivedDateTimeUtc,
        messageId: s.messageId,
        subjectLID: s.subjectLID,
        messageRead: read,
        chatLog: s.chatLog ? JSON.parse(s.chatLog) : [],
        hasAttachment: ((_b = s === null || s === void 0 ? void 0 : s.attachment) === null || _b === void 0 ? void 0 : _b.length) > 0
      });
    };
    var group = removedmessages.reduce(function (r, a) {
      r[(a === null || a === void 0 ? void 0 : a.parentMessageId) == 0 ? a === null || a === void 0 ? void 0 : a.messageId : a === null || a === void 0 ? void 0 : a.parentMessageId] = __spreadArray(__spreadArray([], r[(a === null || a === void 0 ? void 0 : a.parentMessageId) == 0 ? a === null || a === void 0 ? void 0 : a.messageId : a === null || a === void 0 ? void 0 : a.parentMessageId] || [], true), [a], false);
      return r;
    }, {});
    var mess = [];
    Object.keys(group).map(function (s) {
      var _a;
      var messagearray = (_a = group[s]) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
        return new Date(a === null || a === void 0 ? void 0 : a.receivedDateTimeUtc) - new Date(b === null || b === void 0 ? void 0 : b.receivedDateTimeUtc);
      });
      var inbox = messagearray.filter(function (t) {
        return t.senderLID != 200269;
      });
      var sendBox = messagearray.filter(function (t) {
        return t.senderLID == 200269;
      });
      var _loop_1 = function (i) {
        var item = sendBox[i];
        var allm = messagearray.filter(function (e) {
          return e.messageId != item.messageId && moment(e.receivedDateTimeUtc).isBefore(item === null || item === void 0 ? void 0 : item.receivedDateTimeUtc);
        });
        var action = [item].concat(allm);
        mess.push(obj(action));
      };
      for (var i = 0; i < sendBox.length; i++) {
        _loop_1(i);
      }
      var _loop_2 = function (i) {
        var item = inbox[i];
        var allm = messagearray.filter(function (e) {
          return e.messageId != item.messageId && moment(e.receivedDateTimeUtc).isBefore(item === null || item === void 0 ? void 0 : item.receivedDateTimeUtc);
        });
        var action = [item].concat(allm);
        mess.push(obj(action));
      };
      for (var i = 0; i < inbox.length; i++) {
        _loop_2(i);
      }
    });
    mess = mess.sort(function (a, b) {
      return new Date(b.recieved) - new Date(a.recieved);
    });
    var isModPortalVisible = layout.modPortalVisible;
    var borrower = (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.borrowerSummary) === null || _e === void 0 ? void 0 : _e.find(function (e) {
      return parseInt(e.borrowerId) == parseInt(layout.borrowerId);
    });
    var modifications = layout === null || layout === void 0 ? void 0 : layout.modifications;
    var messagecentercomposeclocked = isModPortalVisible && modifications != null && (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) != null && (modifications === null || modifications === void 0 ? void 0 : modifications.isMessageCenterComposeBoxUploadBlocked);
    var inboxAllMessageCount = (_f = (mess || []).filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.direction) != 200269;
    })) === null || _f === void 0 ? void 0 : _f.length;
    var inboxReadMessageCount = (_g = (mess || []).filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.direction) != 200269 && (s === null || s === void 0 ? void 0 : s.messageRead) == true;
    })) === null || _g === void 0 ? void 0 : _g.length;
    var inboxUnreadMessageCount = inboxAllMessageCount > 0 && inboxReadMessageCount > 0 ? inboxAllMessageCount - inboxReadMessageCount : inboxAllMessageCount;
    var messageProps = {
      navigation: this.setNavigation,
      inboxMessageCount: inboxUnreadMessageCount,
      composeTabTitle: translations.ComposeTabTitle,
      sentTabTitle: translations.SentTabTitle,
      inboxTabTitle: translations.InboxTabTitle,
      tableHeader: [translations.Date, translations.ColumnLoanNumber, translations.ColumnFrom, translations.ColumnSubject],
      contactTo: translations.ContactTo,
      regardingLoanId: translations.RegardingLoanId,
      subject: translations.Subject,
      placeHolderText: translations.PlaceHolderText,
      attachFiles: translations.AttachFiles,
      communicationBtnYouAndDebtCollector: "".concat(translations.FileUploadAlert4, "\n").concat(translations.CommunicationBtnYouAndDebtCollector),
      fAQInfo: translations.FAQInfo,
      insuranceInfo: translations.InsuranceInfo,
      typeOfContact: "The Secure Message Team",
      sendMessageText: translations.SendMessageText,
      loanNumber: this.props.layout.selectedLoanNumber,
      subjects: this.getComposeSubjects(this.props.layout.language),
      gridNoItemsText: translations.GridNoItemsText,
      submittMessage: this.submittMessage,
      uploadFile: true,
      messages: mess,
      customerName: "".concat(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerFirstName, " ").concat(borrower === null || borrower === void 0 ? void 0 : borrower.borrowerLastName),
      loanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber,
      showModal: function (show) {
        return _this.setState({
          open: true,
          show: show
        });
      },
      isModification: isModPortalVisible,
      deleteColor: "",
      replyColor: "",
      closeColor: "",
      maxLength: 2999,
      chatLog: this.props.layout.chatMessages,
      fromChat: fromChat,
      onTabChange: this.onTabChange,
      showCompose: messagecentercomposeclocked ? function () {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            border: "1px inset #AAA",
            fontSize: "14px !important "
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            marginLeft: "22px",
            marginTop: "20px"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: 'htmlToNative',
          dangerouslySetInnerHTML: {
            __html: translations === null || translations === void 0 ? void 0 : translations.MortgageAsstCtrText
          }
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            marginLeft: "22px",
            marginTop: "120px",
            marginBottom: "20px"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: 'htmlToNative',
          dangerouslySetInnerHTML: {
            __html: translations === null || translations === void 0 ? void 0 : translations.BackToInbox
          }
        }))));
      } : null,
      renderChatLog: function (fsts) {
        return /*#__PURE__*/React.createElement("div", {
          className: 'htmlToNative',
          dangerouslySetInnerHTML: {
            __html: fsts
          }
        });
      },
      unReadColor: "#f38b1d",
      markRead: function (messageId, callback) {
        var _a;
        if (layout.pennyWise === true) {
          return;
        }
        if ((messageId === null || messageId === void 0 ? void 0 : messageId.length) > 0) {
          var messa = (_a = layout === null || layout === void 0 ? void 0 : layout.messages) === null || _a === void 0 ? void 0 : _a.find(function (s) {
            return s.messageId == messageId[6];
          });
          fetch("api/messages/markread_messages", {
            method: "POST",
            headers: {
              "Authorization": "Bearer ".concat(_this.props.layout.token),
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(messa)
          }).then(function (s) {
            if (s.ok) {
              _this.props.refreshMessages();
            }
          });
        }
      },
      deleteItem: function (messageId, callback) {
        var _a;
        if ((messageId === null || messageId === void 0 ? void 0 : messageId.length) > 0) {
          var messa_1 = (_a = layout === null || layout === void 0 ? void 0 : layout.messages) === null || _a === void 0 ? void 0 : _a.find(function (s) {
            return s.messageId == messageId[6];
          });
          fetch("api/messages/delete_messages", {
            method: "POST",
            headers: {
              "Authorization": "Bearer ".concat(_this.props.layout.token),
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(messa_1)
          }).then(function (s) {
            var _a;
            if (s.ok) {
              callback();
              var inx = (_a = layout === null || layout === void 0 ? void 0 : layout.messages) === null || _a === void 0 ? void 0 : _a.findIndex(function (s) {
                return s.messageId == messa_1.messageId;
              });
              layout.messages.splice(inx, 1);
              _this.props.dispatch({
                type: GET_MESSAGES,
                messages: layout.messages
              });
            }
          });
        }
      },
      isPennyWiseMode: layout.pennyWise
    };
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.messageCenter
      }), /*#__PURE__*/React.createElement(PnmacModal, {
        handleClose: function () {
          return _this.setState({
            open: false,
            show: ""
          });
        },
        open: _this.state.open && _this.state.show != ""
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: "white",
          borderRadius: 10,
          padding: 20,
          maxWidth: matches.small ? "80%" : "500px"
        }
      }, _this.modalContent(show, matches))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations === null || translations === void 0 ? void 0 : translations.Header)), /*#__PURE__*/React.createElement(PnmacMessageCenter, __assign({
        ref: _this.state.messageRef,
        matches: matches
      }, messageProps))), /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginRight: 10,
          marginTop: 20
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, {
        idTags: 'btnLearnMore'
      }, translations === null || translations === void 0 ? void 0 : translations.MessageOnMsgCtr)));
    });
  };
  return MessageCenter;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations,
    language: state.language
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(MessageCenter, function (props) {
  var _a;
  return (_a = props.translations) === null || _a === void 0 ? void 0 : _a.messageCenter;
}));